import t from "lodash/once";
import r from "lodash/isNull";
import e from "lodash/isUndefined";
import n from "lodash/omit";
import o from "lodash/pick";
import i from "lodash/isObject";
import a from "react";
function u(t, r) {
  var e = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    r && (n = n.filter(function (r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function c(t) {
  for (var r = 1; r < arguments.length; r++) {
    var e = null != arguments[r] ? arguments[r] : {};
    r % 2 ? u(Object(e), !0).forEach(function (r) {
      p(t, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : u(Object(e)).forEach(function (r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return t;
}
function l(t) {
  var r = function (t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var n = e.call(t, r || "default");
      if ("object" != typeof n) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }(t, "string");
  return "symbol" == typeof r ? r : r + "";
}
function f(t) {
  return f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
    return typeof t;
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, f(t);
}
function p(t, r, e) {
  return (r = l(r)) in t ? Object.defineProperty(t, r, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[r] = e, t;
}
function s(t) {
  return function (t) {
    if (Array.isArray(t)) return y(t);
  }(t) || function (t) {
    if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
  }(t) || function (t, r) {
    if (!t) return;
    if ("string" == typeof t) return y(t, r);
    var e = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === e && t.constructor && (e = t.constructor.name);
    if ("Map" === e || "Set" === e) return Array.from(t);
    if ("Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return y(t, r);
  }(t) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function y(t, r) {
  (null == r || r > t.length) && (r = t.length);
  for (var e = 0, n = new Array(r); e < r; e++) n[e] = t[e];
  return n;
}
function m(t) {
  return null != t && t.nodeType === Node.ELEMENT_NODE;
}
var b = Object.freeze({
    __proto__: null,
    array: function (t) {
      return null != t && t instanceof Array;
    },
    button: function (t) {
      return m(t) && "button" === t.tagName.toLowerCase();
    },
    element: m,
    input: function (t) {
      return m(t) && "input" === t.tagName.toLowerCase();
    }
  }),
  d = new Map(),
  v = function () {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
      r = function (t) {
        var r,
          e,
          n = (null !== (r = null === (e = d.get(t)) || void 0 === e ? void 0 : e.length) && void 0 !== r ? r : 0).toString().padStart(4, "0");
        return "lg-ui".concat(t ? "-".concat(t) : "", "-").concat(n);
      }(t);
    if (d.has(t)) {
      var e = d.get(t);
      d.set(t, [r].concat(s(e)));
    } else d.set(t, [r]);
    return r;
  };
function g(t) {
  return "string" == typeof (r = t) || "number" == typeof r ? t.toString().trim() : Array.isArray(t) ? t.map(g).join(" ").trim() : function (t) {
    return t && "object" === f(t) && t.props;
  }(t) ? g(t.props.children) : "";
  var r;
}
var h = {
    Light: "light",
    Dark: "dark"
  },
  w = function (t) {
    return t ? h.Dark : h.Light;
  };
function j(t) {
  return 1 == new Set(t).size;
}
var O = function (t) {
    if (t && Array.isArray(t)) {
      var r = s(t);
      return r.reverse(), r;
    }
  },
  S = {
    error: t(console.error),
    warn: t(console.warn),
    log: t(console.log)
  },
  P = function (t) {
    return !e(t) && !r(t);
  },
  A = function (t) {
    return !P(t) || ["", "0", "00", 0].includes(t);
  },
  D = function (t) {
    return !A(t);
  },
  E = function (t, r) {
    return [o(t, r), n(t, r)];
  },
  T = function (t, r, e) {
    var n = e - r;
    return t > e ? r + (t - e - 1) % n : t < r ? e - (r - t - 1) % n : t;
  },
  L = {
    length: 30
  },
  N = function (t) {
    var r = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : L).length;
    return t.length <= r ? t : t.substring(t.length - r);
  };
function k(t, r) {
  var e;
  return null != t && "object" === f(t) && "type" in t && (t.type.displayName === r || i(t.type) && "render" in t.type && (null === (e = t.type.render) || void 0 === e ? void 0 : e.displayName) === r);
}
var C = function (t, r) {
    var n,
      o = null === (n = a.Children.map(t, function (t) {
        if (r.some(function (r) {
          return k(t, r);
        })) return t;
      })) || void 0 === n ? void 0 : n.filter(function (t) {
        return !e(t);
      });
    return e(t) || (null == o ? void 0 : o.length) === a.Children.count(t) || S.error("Children must be one of: ".concat(r.join(", ")), "Received children: ", t), o;
  },
  U = function (t, r) {
    Object.defineProperty(t, "target", {
      writable: !1,
      value: r
    });
    var e = !1,
      n = !1;
    return c(c({
      nativeEvent: t
    }, t), {}, {
      currentTarget: t.currentTarget,
      target: t.target,
      bubbles: t.bubbles,
      cancelable: t.cancelable,
      defaultPrevented: t.defaultPrevented,
      eventPhase: t.eventPhase,
      isTrusted: t.isTrusted,
      timeStamp: t.timeStamp,
      type: t.type,
      preventDefault: function () {
        e = !0, t.preventDefault();
      },
      isDefaultPrevented: function () {
        return e;
      },
      stopPropagation: function () {
        n = !0, t.stopPropagation();
      },
      isPropagationStopped: function () {
        return n;
      },
      persist: function () {}
    });
  };
function _(t) {
  var r = "data-leafygreen-ui";
  return {
    prop: p({}, r, t),
    selector: "[".concat(r, '="').concat(t, '"]')
  };
}
var R = {
    ArrowUp: "ArrowUp",
    ArrowDown: "ArrowDown",
    ArrowLeft: "ArrowLeft",
    ArrowRight: "ArrowRight",
    Backspace: "Backspace",
    BracketLeft: "[",
    Delete: "Delete",
    Enter: "Enter",
    Escape: "Escape",
    Space: " ",
    Tab: "Tab"
  },
  B = {
    Page: "page",
    Step: "step",
    Location: "location",
    Date: "date",
    Time: "time",
    True: "true",
    Unset: "false"
  };
function I(t) {
  throw Error("Received unhandled value: ".concat(t));
}
export { B as AriaCurrentValue, h as Theme, j as allEqual, O as cloneReverse, S as consoleOnce, _ as createDataProp, U as createSyntheticEvent, v as createUniqueClassName, I as enforceExhaustive, g as getNodeTextContent, w as getTheme, k as isComponentType, P as isDefined, D as isNotZeroLike, A as isZeroLike, R as keyMap, E as pickAndOmit, T as rollover, N as truncateStart, b as typeIs, C as validateChildren };